import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { useParams } from "react-router-dom";
import CertificateFormPage from "./CertificateFormPage";
import { FETCH_CERTIFICATE } from "./graphql";

const DEFAULT_CPC_INFO = {
  sampleDescription: "",
  manufacturer: "Waboba AB",
  styleNos: "",
  placeOfManufacturer: "",
  countryOfOrigin: "",
  dateOfManufacturer: "",
  placeOfTesting: "",
  testReportNumber: "",
  dateOfTesting: "",
};

const CertificateLoader = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_CERTIFICATE, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const certificate = data?.certificate;
  const initialValues = {
    isActive: certificate?.isActive ?? true,
    certificateType: certificate?.certificateType || "DOC",
    country: certificate?.country || "",
    title: certificate?.title || "",
    issuedDate: certificate?.issuedDate
      ? moment(certificate.issuedDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
    certificateNumber: certificate?.certificateNumber || "",
    issuer: certificate?.issuer || "",
    validityMonths:
      certificate?.validityMonths === null ||
      certificate?.validityMonths === undefined
        ? "24"
        : String(certificate.validityMonths),
    validUntil: certificate?.validUntil
      ? moment(certificate.validUntil).format("YYYY-MM-DD")
      : "",
    qrCodeExpireDate: certificate?.qrCodeExpireDate
      ? moment(certificate.qrCodeExpireDate).format("YYYY-MM-DD")
      : "",
    cpcInfo: DEFAULT_CPC_INFO,
  };

  return (
    <CertificateFormPage
      mode="edit"
      id={id}
      initialValues={initialValues}
      initialProducts={certificate?.products || []}
      initialTestReports={certificate?.testReports || []}
      initialFiles={certificate?.fileUrls || []}
      initialImageUrls={certificate?.imageUrls || []}
    />
  );
};

export default CertificateLoader;
